import { gql } from '@apollo/client';
import { client } from './client';

export const createTaskReminder = async (variables) => {
  const results = await client.mutate({
    mutation: gql`
      mutation createTaskReminder($taskId: Int!, $input: TaskReminderDefinitionInput!) {
        createTaskReminder(taskId: $taskId, input: $input) {
          id
          setId
          spec
          reminder {
            id
            payload
          }
        }
      }
    `,
    variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  return results;
};

export const updateTaskReminder = async (variables) => {
  const results = await client.mutate({
    mutation: gql`
      mutation updateTaskReminder($taskId: Int!, $definitionId: Int! $input: TaskReminderDefinitionInput!) {
        updateTaskReminder(taskId: $taskId, definitionId: $definitionId, input: $input) {
          id
          setId
          spec
          reminder {
            id
            payload
          }
        }
      }
    `,
    variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  return results;
};

export const deleteTaskReminder = async (variables) => {
  const results = await client.mutate({
    mutation: gql`
      mutation deleteTaskReminder($taskId: Int!, $definitionId: Int!) {
        deleteTaskReminder(taskId: $taskId, definitionId: $definitionId) {
          deleted
        }
      }
    `,
    variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  return results;
};
